<template>
  <div>
    <van-cell-group :border="false" class="module module-audio">
      <van-cell :border="false" class="module-title" title="录音">
        <van-popover
            v-model="audioModePopover.show"
            :actions="audioModePopover.actions"
            placement="left-start"
            theme="dark"
            trigger="click"
            @select="onSelectAudioMode"
        >
          <template slot="reference">
            <div class="switch-mode">{{ audioModePopover.selected.text }}
              <van-icon name="arrow-down" size="14"/>
            </div>
          </template>
        </van-popover>
      </van-cell>
      <van-cell>
        <div class="record-status">
          <template v-if="audio == null">
            <template v-if="audioModePopover.selected.value == 'upload'">
              <input ref="input-audio" type="file" accept="audio/x-mpeg,audio/mpeg,audio/mp3,audio/x-m4a,audio/mp4a-latm,audio/vnd.dlna.adts,audio/aac" @change="onSelectAudio">
              <van-icon class="icon" name="add"/>
              <div class="text">上传录音文件</div>
            </template>
            <template v-else-if="audioModePopover.selected.value == 'record'">
              <template v-if="!record.isRecording">
                <i class="icon iconfont icon-record" @click="handleRecordStart"></i>
                <div class="text">点击开始录音</div>
              </template>
              <template v-else>
                <i class="icon iconfont icon-record recording" @click="handleRecordStop"></i>
                <div class="text">点击停止录音<br>{{ record.countdown }}秒后自动停止</div>
              </template>
            </template>
          </template>
          <template v-else>
            <template v-if="player.status == 0">
              <van-icon class="icon" color="var(--primary-color)" name="play-circle" @click="playAudio"/>
              <div class="text">播放录音</div>
            </template>
            <template v-if="player.status == 1">
              <van-icon class="icon" color="var(--primary-color)" name="pause-circle" @click="stopAudio"/>
              <div class="text">停止播放</div>
            </template>
          </template>
        </div>
      </van-cell>
      <van-cell v-if="audio != null" >
        <div class="text-center">
          <div class="btn-rerecording" @click="onRerecord">
            <van-icon name="replay" size="14"/>
            {{ audioModePopover.selected.value == 'upload' ? '重新上传' : '重录' }}
          </div>
        </div>
      </van-cell>
    </van-cell-group>

    <div v-if="audioModePopover.selected.value == 'upload'" class="padding-sm text-grey">苹果手机录音后点击“存储到文件”，然后才能上传录音。</div>

    <div class="text-center margin-tb padding">
      <van-button type="info" size="large" @click="submit">保存</van-button>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import {CellGroup, Cell, Button, Icon, Toast, Dialog, Uploader, Popover} from 'vant';
import {updateAudio} from '@/api/clerk/clerk'
import {audioToMp3, wxAudioMediaIdToMp3} from "@/api/file"
import {wx, wxConfig} from "@/libs/jssdk-util";

Vue.use(CellGroup)
    .use(Cell)
    .use(Button)
    .use(Icon)
    .use(Toast)
    .use(Dialog)
    .use(Uploader)
    .use(Popover)

export default {
  name: 'updateAudio',
  data() {
    return {
      itemType: this.$route.query.itemType,
      audioModePopover: {
        show: false,
        selected: {
          text: '直接录音',
          value: 'record'
        },
        actions: [{
          text: '上传手机音频',
          value: 'upload'
        }, {
          text: '直接录音',
          value: 'record'
        }]
      },
      audio: null,
      record: {
        isRecording: false,
        countdown: 20,
        _countdown: 20,
        countdownTimer: null,
        audioLocalId: null, // 音频本地ID
        audioServerId: null, // 音频服务器ID
      },
      player: {
        status: 0,
        audio: null
      },
    }
  },
  methods: {
    onSelectAudioMode(action) {
      if (this.audioModePopover.selected.value != action.value) {
        this.audioModePopover.selected = action

        this.record.isRecording = false
        this.audio = null
        if (this.player.audio != null) {
          this.player.audio.pause()
        }
      }
    },
    onRerecord() {
      this.audio = null
      if (this.player.audio != null) {
        this.player.audio.pause()
      }
    },
    onSelectAudio() {
      const vm = this
      const files = this.$refs['input-audio'].files
      if (files.length > 0) {
        const file = files[0]
        if (['audio/x-mpeg', 'audio/mpeg', 'audio/mp3', 'audio/x-m4a', 'audio/mp4a-latm', 'audio/vnd.dlna.adts', 'audio/aac'].indexOf(file.type) == -1) {
          if (file.name != null && file.name.lastIndexOf('.') != -1) {
            let ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase()
            if (['mp3', 'm4a', 'amr'].indexOf(ext) == -1) {
              return Toast('仅支持请上传m4a或mp3格式')
            }
          } else {
            return Toast('仅支持请上传m4a或mp3格式')
          }
        }
        if (file.size > 1 * 1024 * 1024) {
          return Toast('音频大小不能超过1M')
        }

        Toast.loading({
          mask: true,
          duration: 0,
          message: '音频上传中'
        })
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          audioToMp3(e.target.result).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              const base64 = 'data:audio/mpeg;base64,' + data.audio
              vm.audio = base64
              vm.player.status = 0
            } else {
              Dialog.alert({
                title: '上传音频失败',
                message: data.msg
              })
            }
          })
        }
      }
    },
    // 开始录音
    handleRecordStart() {
      let that = this
      wx.startRecord({
        success: function () {
          clearInterval(that.record.countdownTimer)
          that.record.isRecording = true
          // 倒计时结束自动停止录音
          that.record.countdown = that.record._countdown
          that.record.countdownTimer = setInterval(() => {
            that.record.countdown--
            if (that.record.countdown <= 0) {
              clearInterval(that.record.countdownTimer)
              that.handleRecordStop()
            }
          }, 1000)
        },
        fail(err) {
          that.record.isRecording = false
          Dialog.alert({
            title: '开始录音失败',
            message: err.errMsg
          })
        }
      })
    },
    // 停止录音
    handleRecordStop() {
      let vm = this
      if (this.record.isRecording) {
        this.record.isRecording = false

        Toast.loading({
          mask: true,
          duration: 0,
          message: '音频上传中'
        })
        wx.stopRecord({
          success: function (res) {
            wx.uploadVoice({
              localId: res.localId,
              isShowProgressTips: 1, // 默认为1，显示进度提示
              success(res) {
                const mediaId = res.serverId

                wxAudioMediaIdToMp3(mediaId).then(res => {
                  Toast.clear()
                  const data = res.data;
                  if (data.code == 0) {
                    const base64 = 'data:audio/mpeg;base64,' + data.audio
                    vm.audio = base64
                  } else {
                    Dialog.alert({
                      title: '上传音频失败',
                      message: data.msg
                    })
                  }
                })
              },
              fail(err) {
                Toast.clear()
                Dialog.alert({
                  title: '上传录音失败',
                  message: err.errMsg
                })
              }
            })
          },
          fail(err) {
            Toast.clear()
            Dialog.alert({
              title: '停止录音失败',
              message: err.errMsg
            })
          }
        })
      }
    },
    // 播放录音
    playAudio() {
      this.player.audio = new Audio(this.audio)
      this.player.audio.play()
      this.player.status = 1
      // 播放结束事件
      this.player.audio.onended = () => {
        this.player.status = 0
      }
    },
    // 停止播放录音
    stopAudio() {
      this.player.audio.pause()
      this.player.status = 0
    },
    submit() {
      if (this.audio == null) {
        return Toast('请上传录音');
      }
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      updateAudio(this.audio,this.itemType === 'gaming' ? this.itemType : null).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '提交成功'
          }).then(() => {
            this.$router.back(-1)
          })
        } else {
          Dialog.alert({
            title: '修改失败',
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    wxConfig(['startRecord', 'stopRecord', 'playVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice'])
    wx.error(function (err) {
      Dialog.alert({
        title: '微信配置失败，请刷新页面',
        message: JSON.stringify(err)
      })
    });

  },
  beforeRouteLeave(to, form, next) {
    if (this.record.isRecording) {
      let that = this;
      wx.stopRecord({
        success: function () {
          that.record.isRecording = false
        }
      })
    }
    if (this.player.audio != null) {
      this.player.audio.pause()
    }
    next()
  }
}
</script>

<style lang="less" scoped>
.module-audio {

  .switch-mode {
    display: inline-flex;
    align-items: center;
    color: #333;
    font-size: 14px;
    height: 20px;
    line-height: 20px;

    .van-icon {
      margin-right: 3px;
    }
  }

  .record-status {
    position: relative;

    .icon {
      width: 80px;
      height: 80px;
      color: var(--primary-color);
      font-size: 60px;
      border-radius: 50%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;

      &.recording {
        @keyframes twinkling {
          0% {
            opacity: 0.5;
            transform: scale(0.9);
          }
          50% {
            opacity: 1;
            transform: scale(1);
          }
          100% {
            opacity: 0.5;
            transform: scale(0.9);
          }
        }
        animation: twinkling 1s infinite ease-in-out;
        animation-fill-mode: both;
      }
    }

    .text {
      color: #999;
      font-size: 16px;
      text-align: center;
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      cursor: pointer;
      opacity: 0;
      z-index: 3;
    }

    .btn-rerecording {
      display: inline-flex;
      color: #333;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      align-items: center;
      .van-icon {
        margin-right: 3px;
      }
    }
  }
}
</style>
